import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id DC82606F-2ABB-4C09-BAC5-1C3C4DA38BEC
 * name shield-half
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-half.svg
 * tags
 */
export const ShieldHalfIcon = createSvgIcon(<><path d="M12 1L3 5V11C3 16.5 6.8 21.7 12 23V1Z" /></>, 'ShieldHalfIcon');
export default ShieldHalfIcon